import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initTheme } from "./hooks/useTheme";
import BrandIntro from "./components/BrandIntro";
import { initNativeShell } from "./lib/native-setup";
import { initializeAds } from "./lib/native-ads";
import { initializePush } from "./lib/native-push";

initTheme();
// Configure status bar / edge-to-edge on native. No-op on web.
void initNativeShell();
// Initialize AdMob once on boot. No-op on web/iOS.
void initializeAds();
// Register for push notifications and persist FCM token. No-op on web.
void initializePush({
  onNotificationTap: (data) => {
    // Deep-link router: when a push has { route: "/app/result/:id" }, navigate.
    const route = typeof data?.route === "string" ? data.route : null;
    if (route) {
      // Defer so React Router is ready.
      setTimeout(() => {
        window.location.assign(route);
      }, 50);
    }
  },
});

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    {/* Cinematic native launch overlay — only renders on Android/iOS, once per session. */}
    <BrandIntro />
  </>,
);

// Fade out the boot-loader (defined in index.html) once React has painted.
// Two animation frames guarantees the first React frame is on-screen first.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const el = document.getElementById("boot-loader");
    if (el) {
      el.classList.add("hide");
      window.setTimeout(() => el.remove(), 320);
    }
  });
});
